import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import moment from "moment";
import { fetchTempsSurPlace } from "../CommandesFournisseurs/DataService";

/**
 * Temps passé chez le client, mesuré sur le GPS du livreur, face au temps prévu
 * (déchargement selon le poids + manutention). Calcul serveur :
 * ArretLivreurService::tempsSurPlace, le même que la mesure
 * livreurs:analyser-arrets.
 */

// Au-delà du prévu, combien de minutes avant de passer au rouge.
const MARGE_ORANGE_MINUTES = 15;

const RAISONS = {
  pas_partie: null,
  adresse_sans_coordonnees: "adresse de livraison sans coordonnées GPS",
  heures_de_course_inconnues: "heures de départ ou de livraison non pointées",
  pas_de_position: "pas de position GPS du livreur pendant la course",
  aucun_arret_a_l_adresse: "aucun arrêt mesuré à l'adresse (livraison éclair ou téléphone silencieux)",
};

const couleur = (minutes, prevu) => {
  if (minutes <= prevu) return "success";
  if (minutes <= prevu + MARGE_ORANGE_MINUTES) return "warning";
  return "danger";
};

const TempsSurPlace = ({ idCommande, statut }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    let annule = false;
    fetchTempsSurPlace(idCommande)
      .then((r) => !annule && setData(r))
      .catch((e) => console.error("Erreur temps sur place:", e));
    return () => {
      annule = true;
    };
  }, [idCommande, statut]);

  if (!data) return "-";

  if (!data.mesure) {
    const raison = RAISONS[data.raison];
    return (
      <>
        prévu {data.prevu} min
        {raison && <span className="text-muted small"> — non mesuré : {raison}</span>}
      </>
    );
  }

  const heure = (d) => moment(d).format("HH:mm");

  return (
    <>
      <Badge
        bg={couleur(data.minutes, data.prevu)}
        text={couleur(data.minutes, data.prevu) === "warning" ? "dark" : undefined}
        title={
          data.borne_haute
            ? "Le téléphone du livreur s'est tu pendant une partie de l'arrêt : durée maximale, le livreur a pu repartir plus tôt."
            : undefined
        }
      >
        {data.en_cours ? "sur place depuis " : ""}
        {data.borne_haute ? "jusqu'à " : ""}
        {data.minutes} min
      </Badge>{" "}
      <span>prévu {data.prevu} min</span>
      <span className="text-muted small">
        {" "}
        ({heure(data.arrivee)} → {heure(data.depart)})
      </span>
    </>
  );
};

export default TempsSurPlace;
